import { null as zNull } from "zod/v4";

export const disconnectCloudXIntegration = {
  name: "disconnectCloudXIntegration" as const,
  input: zNull(),
  output: zNull(),
};
